import React from 'react';
import _ from 'lodash';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function PreRegistrationRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  const regRules = stateData.registration_laws.html;
  const minRegAge = stateData.minimum_age_register.text;
  const regNotes = stateData.minimum_age_register.footnotes;

  configureAnchors({ offset: -75, scrollDuration: 300 });

  return (
    <TableRow>
      <TableData>
        <ScrollableAnchor id={stateSlug}>
          <a
            href={`/how-to-vote/${stateSlug}/`}
            title={`How to vote in ${stateName}`}
          >
            {stateName}
          </a>
        </ScrollableAnchor>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Voter registration rules',
            valueHtml: regRules,
          },
          {
            title: 'Minimum age to register',
            valueNode: minRegAge,
          },
          {
            title: 'Notes',
            valueNode: regNotes,
          },
          {
            title: 'Register to vote',
            valueNode: (
              <Link
                to={withPrefix(`/register-to-vote/${stateSlug}/`)}
                title={`Register to vote in ${stateName}`}
              >
                Register to vote in {stateName}
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

PreRegistrationRowRenderer.propTypes = rowRendererProps;
